<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" role="doc-dedication">
<p class="DED" id="ded"><span aria-label="v" id="pg_v" role="doc-pagebreak">ONCE AGAIN<br/>TO</span></p>
<p class="DED1">ZELDA</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0d4d2518